// src/FirebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, initializeAuth, indexedDBLocalPersistence, connectAuthEmulator } from "firebase/auth";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";

// Fog of War BetaV1's Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyBqLfJlBsinWYsDmaRI6aGRWNW_S62zbw0",
  authDomain: "fogofwar-betav1.firebaseapp.com",
  databaseURL: "https://fogofwar-betav1-default-rtdb.firebaseio.com",
  projectId: "fogofwar-betav1",
  storageBucket: "fogofwar-betav1.appspot.com",
  messagingSenderId: "1049062092951",
  appId: "1:1049062092951:web:d6b611e852a07cba61f9d2"
};

// REACT_APP_EMULATORS=1 (npm run start:emulators): everything talks to the
// local Firebase emulators on the offline demo project, never to production
// (functions/scripts/with-emulators.mjs starts them).
export const USE_EMULATORS = process.env.REACT_APP_EMULATORS === "1";
export const EMULATOR_PROJECT = "demo-hog";

// Initialize Firebase
const app = initializeApp(USE_EMULATORS
  ? { ...firebaseConfig, projectId: EMULATOR_PROJECT, databaseURL: `http://127.0.0.1:9000?ns=${EMULATOR_PROJECT}` }
  : firebaseConfig);

// Initialize Firebase services
// Inside the native shell (Capacitor) getAuth's popup/redirect resolver tries
// to load Google's auth iframe from a non-web origin and auth can hang, so the
// native app uses IndexedDB persistence with no resolver. The web is unchanged.
const isNativeShell = typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();
const auth = isNativeShell
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);
const db = getDatabase(app);
if (USE_EMULATORS) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectDatabaseEmulator(db, "127.0.0.1", 9000);
}

// Export the Firebase services
export { app, auth, db };
